import React, { useState } from "react";
import axios from 'axios';  
export default function Form() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    msg_subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

 

const handleSubmit = async (e) => {  
  e.preventDefault();  
  setLoading(true);  
  setErrorMessage('');  

  try {  
    const response = await axios.post('https://api.vsktextiles.com/api/send-email', formData, {  
      headers: {  
        'Content-Type': 'application/json',  
      },  
    });  

    // Handle response  
    if (response.status !== 200) {  
      console.error('Error Response:', response.data);  
      throw new Error(`HTTP error! Status: ${response.status}`);  
    }  

    alert('Message sent successfully!');  
    setFormData({  
      name: '',  
      email: '',  
      phone_number: '',  
      msg_subject: '',  
      message: '',  
    });  
  } catch (error) {  
    console.error('Error:', error);  
    setErrorMessage(error.message || 'An error occurred while sending your message.');  
  } finally {  
    setLoading(false);  
  }  
};


  return (
    <>
      <section className="contact-area ptb-80">
        <div className="container">
          <div className="section-title">
            <h2>Get In Touch With Us</h2>
            <div className="bar"></div>
            <p>Anything On your Mind. We’ll Be Glad To Assist You!</p>
          </div>

          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12">
              <img src="/img/contact.png" alt="Contact" />
            </div>
            <div className="col-lg-6 col-md-12">
              <form id="contactForm" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control"
                        required
                        placeholder="Name"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control"
                        required
                        placeholder="Email"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-6">
                    <div className="form-group">
                      <input
                        type="number"
                        maxLength={10}
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="Phone"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="msg_subject"
                        value={formData.msg_subject}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="Subject"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="form-control"
                        required
                        placeholder="Your Message"
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </div>

                  {errorMessage && (
                    <div className="col-lg-12 col-md-12">
                      <div className="alert alert-danger">{errorMessage}</div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
